import { render, staticRenderFns } from "./items-in-workspace.vue?vue&type=template&id=7b3e6a65&scoped=true&"
import script from "./items-in-workspace.vue?vue&type=script&lang=ts&"
export * from "./items-in-workspace.vue?vue&type=script&lang=ts&"
import style0 from "./items-in-workspace.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./items-in-workspace.vue?vue&type=style&index=1&id=7b3e6a65&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b3e6a65",
  null
  
)

export default component.exports